import {useEffect, useState} from 'react';
import {loadCsvData} from '../utils/loadCsvData';
import RewardSlider from '../components/RewardSlider';

import 'swiper/css';
import 'swiper/css/pagination';

const sectionNameList = [
    {sectionName: '행운의 포춘쿠키', section: [1, 2, 3, 4, 5, 6, 7], view: ['Lv1', 'Lv2', 'Lv3', 'Lv4', 'Lv5', 'Lv6', 'Lv7']},
    {sectionName: '마법의 솥단지', section: [8, 9], view: ['하트', '골드']},
    {sectionName: '캡슐 머신', section: [10], view: ['캡슐 확률']}];

function RewardPage() {
    const [data, setData] = useState([]);

    useEffect(() => {
        loadCsvData().then((data) => {
            console.log("Loaded CSV data:", data);
            setData(data);
        });

    }, []);
    return (
        <RewardSlider sectionData={sectionNameList} data={data} />
    );
}

export default RewardPage;
